<template>
  <div v-loading="loading" id="chartHeatmap" element-loading-background="transparent"
    style="height: 200px;width: 100%;" />
</template>

<script>
import { debounce } from '@/utils/common'
import { getBehavioractivationApi } from '@/api/up/upMemberApi'
export default {
  name: 'MemberActiveHeatmap',
  props: {
    memberid: {
      type: Number,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      chart: null,

      chartOption: {
        tooltip: {
          position: 'top',
          formatter: function (p) {
            return '日期：' + p.data[0] + '<br/>' + '活跃度：' + p.data[1];
          }
        },
        visualMap: {
          min: 0,
          max: 50,
          type: 'piecewise',
          orient: 'horizontal',
          right: '15%',
          bottom: 10,
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 2,
          text: ['More', 'Less'],
          textStyle: {
            color: '#888',
            fontSize: 10
          },
          inRange: {
            color: ['rgba(7,193,96, 0.1)', 'rgba(7,193,96, 1)'],
            symbolSize: [30, 100]
          }
        },
        calendar: [
          {
            left: 'center',
            cellSize: [36, 28],
            top: 60,
            orient: 'vertical',
            itemStyle: {
              color: '#eee',
              borderColor: '#fff',
            },
            splitLine: {
              show: false
            },
            yearLabel: {
              show: false
            },
            monthLabel: {
              nameMap: 'cn',
              color: '#888',
              fontSize: 10
            },
            dayLabel: {
              nameMap: 'cn',
              color: '#888',
              fontSize: 10
            },
            range: [],
          }
        ],
        series: [
          {
            type: 'heatmap',
            coordinateSystem: 'calendar',
            calendarIndex: 0,
            data: []
          }
        ]
      }
    }
  },

  computed: {
    max() {
      let arr = this.chartOption.series[0].data
      let newarr = []
      if (arr.length) {
        newarr = arr.map(v => {
          let y = v[1]
          return y
        })
      }
      return newarr.sort(function (a, b) { return b - a })[0]
    }
  },

  watch: {
    max() {
      if (this.max > 50) this.chartOption.visualMap.max = this.max
      this.chart.setOption(this.chartOption)
    }
  },

  created: function () {
    this.fetchData()
  },
  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestroy() {
  },
  methods: {
    fetchData() {
      this.loading = true
      getBehavioractivationApi({ memberid: this.memberid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.chartOption.calendar[0].range = [res.data[0][0], res.data[res.data.length - 1][0]]
          this.chartOption.series[0].data = res.data
          if (this.chart) {
            this.chart.setOption(this.chartOption)
          }
        }
      })
    },

    initChart() {
      this.chart = this.$echarts.init(document.getElementById('chartHeatmap'), 'teenager')
      this.chart.setOption(this.chartOption)
    }
  }
}
</script>
